// extracted by mini-css-extract-plugin
module.exports = {"container":"IssueCard_container__nMnGk","header":"IssueCard_header__bLMf6","content":"IssueCard_content__kEN2T","footer":"IssueCard_footer__1SP0Z"};